<template>
  <div>
    <PersonList :persons="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import PersonList from '@/components/PersonList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'PersonGender',
  components: {
    PersonList,
    FixedPopup,
    InfiniteLoading
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]       
    }
  },
  data () {
    return {
      page: 2,
      studio: '',
      url: '',
      dorms: null,
      errors: [],
      gender: '',
      typeID: null,
      popupDorms: null,
      details: null
    }
  },
  methods: {
    checkGender () {
      if (this.$route.params.type === 'male') {
        this.gender = 'Male'
        this.typeID = 2
      } else if (this.$route.params.type === 'female') {
        this.gender = 'Female'
        this.typeID = 1
      }
    },
    getDorms () {
      this.checkGender()
      let self = this
      self.dorms = null
      this.studioId = window.localStorage.getItem('studioId')
      axios
        .get(`/3/person/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&page=1`)
        .then(response => {
           self.dorms = []
              response.data.results.forEach(item => {
                  if(item.gender == self.typeID) {
                      self.dorms.push(item)
                  }
                
              })
          // self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    infiniteHandler ($state) {
      let self = this
      axios
        .get(`/3/person/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&page=${this.page}`)
        .then(response => {
          if (response.data.results) {
            this.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (response.data.results.length !== 0) {
              response.data.results.forEach(item => {
                  if(item.gender == this.typeID) {
                      self.dorms.push(item)
                  }
                
              })
              // self.popupDorms = response.data.results.popups
              $state.loaded()
            } else {
              $state.complete()
            }
          }
        })
    },   
  },
  computed: {
    ...mapGetters(['universityDetails']),
    pageTitle () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_title
        else if (this.typeID === 2) title = this.universityDetails.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_description
        else if (this.typeID === 2) title = this.universityDetails.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_keywords
        else if (this.typeID === 2) title = this.universityDetails.female_keywords
      }
      return title
    }
  },
  created () {
    this.getDorms()
    this.url = window.location.origin + this.$route.fullPath //  '/' + this.$route.params.slug + '-movies/'
  },
  watch: {
    $route () {
      this.checkGender()
      this.getDorms()
    }
  }
}
</script>

<style scoped>

</style>
